import { defineMessages } from "react-intl";

const messages = defineMessages({
  bulkDelete: {
    id: "resources.resource.delete.bulk.success",
    defaultMessage:
      "{total, plural, one {Resource} other {Resources}} {isTrash, select, true {permanently deleted} other {moved to trash}}",
    description: "Resource delete success message",
  },
  bulkDeleteError: {
    id: "resources.resource.delete.bulk.error",
    defaultMessage:
      "Unable to {isTrash, select, true {permanently } other {}}delete {total, plural, one {resource} other {resources}}",
    description: "Resource delete error message",
  },
  emptyTrashError: {
    id: "resources.resource.emptyTrash.error",
    defaultMessage: "Unable to empty trash",
    description: "Resource emptyTrash error message",
  },
  emptyTrashSuccess: {
    id: "resources.resource.emptyTrash.success",
    defaultMessage: "Trash emptied",
    description: "Resource emptyTrash success message",
  },
  errorDescription: {
    id: "resources.update.generic.error.description",
    defaultMessage: "Please try again or contact support if the issue continues.",
    description: "Resources generic error description",
  },
  folderBulkDeleteError: {
    id: "resources.folder.delete.bulk.error",
    defaultMessage: "Unable to delete {total, plural, one {folder} other {folders}}",
    description: "Bulk folder delete error message",
  },
  folderBulkDeleteSuccess: {
    id: "resources.folder.delete.bulk.success",
    defaultMessage: "{total, plural, one {Folder} other {Folders}} deleted",
    description: "Bulk folder delete success message",
  },
  folderBulkEditError: {
    id: "resources.folder.edit.bulk.error",
    defaultMessage: "Unable to update {total, plural, one {folder} other {folders}}",
    description: "Bulk folder edit error message",
  },
  folderCreateError: {
    id: "resources.folder.create.error",
    defaultMessage: "Unable to create folder",
    description: "Folder create error message",
  },
  folderDeleteError: {
    id: "resources.folder.delete.error",
    defaultMessage: "Unable to delete folder",
    description: "Folder delete error message",
  },
  folderUpdateError: {
    id: "resources.folder.update.error",
    defaultMessage: "Unable to update folder",
    description: "Folder update error message",
  },
  pinUnpinError: {
    id: "resources.resource.pinUnpin.error",
    defaultMessage: "Unable to {unpin, select, true {unpin} other {pin}} resource",
    description: "Resource pin/unpin error message",
  },
  pinUnpinSuccess: {
    id: "resources.resource.pinUnpin.success",
    defaultMessage: "Resource {unpin, select, true {unpinned} other {pinned}}",
    description: "Resource pin/unpin success message",
  },
  resourceDelete: {
    id: "resources.resource.delete.success",
    defaultMessage:
      "{resourceName} {isTrash, select, true {permanently deleted} other {moved to trash}}",
    description: "Resource delete success message",
  },
  resourceDeleteError: {
    id: "resources.resource.delete.error",
    defaultMessage: "Unable to {isTrash, select, true {permanently } other {}}delete resource",
    description: "Resource delete error message",
  },
  resourcesCreateError: {
    id: "resources.resource.create.error",
    defaultMessage: "Unable to add {count, plural, one {resource} other {resources}}",
    description: "Resource create error message",
  },
  resourcesCreateSuccess: {
    id: "resources.resource.create.success",
    defaultMessage: "{count, plural, one {Resource} other {Resources}} added",
    description: "Resource create success message",
  },
  storageLimitError: {
    id: "resources.resource.create.storageLimitError",
    defaultMessage: "Storage limit reached",
    description: "Resource bulk create error message",
  },
  storageLimitErrorDescription: {
    id: "resources.resource.create.storageLimitError.description",
    defaultMessage:
      "{isMember, select, true {Please ask your admin to upgrade your storage capacity or remove files to continue} other {Please upgrade your storage capacity or remove files to continue}}.",
    description: "Resource bulk create error message",
  },
  updateError: {
    id: "resources.resource.update.error",
    defaultMessage: "Unable to update resource",
    description: "Resource update error message",
  },
  upgrade: {
    id: "resources.resource.storage.upgrade",
    defaultMessage: "Upgrade",
    description: "Resource storage upgrade button message",
  },
});

export default messages;
